angular.module('jv.MyAccount.Breadcrumb.Ctrl', [])
    .controller('BreadcrumbCtrl', ['$scope', '$rootScope','Breadcrumbs', function($scope,$rootScope, breadcrumbs) {
        $scope.breadcrumbs = breadcrumbs;
        $scope.$on('changeBreadCrumb',function(e,v){
            $scope.breadcrumbs[1].text=v;
        });
    }]);